import { render, staticRenderFns } from "./EmdFooterExternal.vue?vue&type=template&id=32921232&"
import script from "./EmdFooterExternal.vue?vue&type=script&lang=js&"
export * from "./EmdFooterExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports